import type { Account } from '@zeni/shared'

/**
 * 口座の表示順（displayOrder）の付け替え。
 *
 * displayOrder は口座もクレジットカードも区別せず、ユーザーごとに 1 本の並びとして持つ。
 * そのため口座ページ・カードページのどちらから動かしても、並べ替えの対象はそのページに
 * 見えているカードだけでも、番号は全口座を通して振り直す。ページごとに 0 から振ると
 * 番号が重なり、口座とカードを混ぜて出す画面（ダッシュボードなど）で順序が定まらない。
 */

/** moving を target の位置へ動かした新しい並びを返す（元の配列は変更しない） */
export function moveAccount(all: Account[], movingId: string, targetId: string): Account[] {
  if (movingId === targetId) return all
  const from = all.findIndex((a) => a.id === movingId)
  const to = all.findIndex((a) => a.id === targetId)
  if (from < 0 || to < 0) return all

  const next = [...all]
  const [moved] = next.splice(from, 1)
  // 取り除いた後に target の位置へ差し込む。後ろへ動かすときは target の直後、
  // 前へ動かすときは target を押し出してその位置に入る
  next.splice(to, 0, moved)
  return next
}

/** 並びを 0 からの通し番号にして、reorder API に渡す形にする */
export function accountOrderItems(all: Account[]): { id: string; displayOrder: number }[] {
  return all.map((a, i) => ({ id: a.id, displayOrder: i }))
}
